import { NgModule } from '@angular/core';
import { NumberChangeAddClassDirective } from './number-change-add-class.directive';

@NgModule({
  declarations: [NumberChangeAddClassDirective],
  exports: [NumberChangeAddClassDirective],
})
export class NumberChangeAddClassModule {}
